export default "__VITE_ASSET__Dxz9hYik__"